export default "__VITE_ASSET__B8VLtD0H__"